export default __webpack_public_path__ + "static/media/cardShadow.d95b9797.svg";